import React, { FC, memo } from 'react';

import { useAccountContext } from 'application/providers/AccountProvider';
import ProfileButton from 'application/components/ProfileButton';
import PhoneUtils from 'application/utils/PhoneUtils';

import styles from './index.module.scss';

export type ProfileInfoModalProps = {
  onChangePasswordClick: () => void;
  onLogoutClick: () => void;
};

const ProfileInfoModal: FC = () => {
  const { currentUser } = useAccountContext();

  return (
    <div className={styles.container}>
      <div>
        <ProfileButton />
      </div>
      <div className={styles.content}>
        <div
          className={styles.title}
          data-testid="profile_info_modal_email">
          {currentUser?.email}
        </div>
        <div className={styles.subtitle}>{PhoneUtils.formatPhoneNumber(currentUser?.phone || '')}</div>
      </div>
    </div>
  );
};

export default memo(ProfileInfoModal);
